<template>
  <div id="contenedor-main-licitacion-eventos">
    <!-- ToolBar -->
    <tool-bar
      class="my-3"
      v-on:agregarEventoLicitacion="agregarEventoLicitacion">
    </tool-bar>
    <!-- Listado de Eventos de Licitacion -->
    <listado :licitacionEventos="getLicitacionCalendario" />
    <!-- Ventana Agregar Evento de licitación. -->
    <v-dialog
      v-model="mostrarVentanaAgregarEvento"
      :width="!$vuetify.breakpoint.mobile ? '500' : '90%'">
      <agregar-evento
        :idLicitacion="idLicitacion"
        v-on:cerrar="cerrarVentana"/>
    </v-dialog>
    <!-- Ventana Editar Evento de Licitación. -->
    <v-dialog
      v-if="esteEvento"
      v-model="mostrarVentanaEditarEvento"
      :width="!$vuetify.breakpoint.mobile ? '500' : '90%'">
      <editar-evento
        :eventoLicitacionEditar="esteEvento"
        v-on:cerrar="cerrarVentana"/>
    </v-dialog>
    <!-- Ventana Eliminar Evento de Licitación. -->
    <v-dialog
      v-if="esteEvento"
      v-model="mostrarVentanaEliminarEvento"
      :width="!$vuetify.breakpoint.mobile ? '450' : '90%'">
      <eliminar-evento
        :eventoLicitacionEliminar="esteEvento"
        v-on:cerrar="cerrarVentana"/>
    </v-dialog>
  </div>
</template>

<script>
import LICITACION_CALENDARIO from '@/graphql/querys/administracion/licitaciones/calendario/licitacionCalendario.gql';
import Listado from './listado/Main.vue';
import ToolBar from './ToolBar.vue';
import eventBus from '@/helpers/eventBus';
import AgregarEvento from '@/components/administracion/licitaciones/eventos/Nuevo.vue';
import EditarEvento from '@/components/administracion/licitaciones/eventos/Editar.vue';
import EliminarEvento from '@/components/administracion/licitaciones/eventos/Eliminar.vue';

export default {
  name: 'MainLicitacionEventos',
  components: {
    Listado,
    ToolBar,
    AgregarEvento,
    EditarEvento,
    EliminarEvento,
  },

  data() {
    return {
      mostrarVentanaAgregarEvento: false,
      mostrarVentanaEditarEvento: false,
      mostrarVentanaEliminarEvento: false,
      esteEvento: null,
      idLicitacion: this.$route.params.idLicitacion,
    };
  },
  apollo: {
    licitacionCalendario: {
      query: LICITACION_CALENDARIO,
      variables() {
        return {
          id: this.$route.params.idLicitacion,
        };
      },
    },
  },
  methods: {
    agregarEventoLicitacion() {
      this.mostrarVentanaAgregarEvento = true;
    },
    cerrarVentana() {
      this.mostrarVentanaAgregarEvento = false;
      this.mostrarVentanaEditarEvento = false;
      this.mostrarVentanaEliminarEvento = false;
      this.esteEvento = null;
    },
  },
  computed: {
    getLicitacionCalendario() {
      if (!this.licitacionCalendario) return [];
      return this.licitacionCalendario;
    },
  },
  mounted() {
    eventBus.$on('editar-evento-licitacion', (eventoLicitacion) => {
      this.esteEvento = eventoLicitacion;
      this.mostrarVentanaEditarEvento = true;
    });
    eventBus.$on('eliminar-evento-licitacion', (eventoLicitacion) => {
      this.esteEvento = eventoLicitacion;
      this.mostrarVentanaEliminarEvento = true;
    });
  },
};
</script>

<style lang="scss">
</style>
